import styled from 'styled-components';

import { Modal } from '@creditornot/cbt-modal';

import { ModalContent } from './ModalContent';
import { SubmitStateBadge } from '../SubmitStateBadge';

const Content = styled(ModalContent)`
  height: 152px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

type Props = {
  isLoading?: boolean;
  isSuccess?: boolean;
  loadingText?: string;
  successText?: string;
  hideText?: boolean;
  isMobileOptimized?: boolean;
};

export const SubmitStateModal: React.FC<Props> = ({
  isLoading,
  isSuccess,
  loadingText,
  successText,
  hideText = false,
  isMobileOptimized,
}: Props) => {
  const isOpen = !!isLoading || !!isSuccess;

  return (
    <Modal open={isOpen} sizePreset="centered:small">
      <Content>
        <SubmitStateBadge
          isLoading={isLoading}
          loadingText={loadingText}
          successText={successText}
          hideText={hideText}
          isMobileOptimized={isMobileOptimized}
        />
      </Content>
    </Modal>
  );
};
